import { Box, Flex, Grid, styled, FloraButton } from '@grupoboticario/flora-react';

export const styles = {
  ButtonLoadMore: styled(FloraButton, {
    marginBottom: '$6',
  }),

  Orders: styled(Grid, {
    gap: '$4',
    padding: '$6 0',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($20 * 4), 1fr))',
    },
  }),

  OrdersWrapper: styled('div', {
    background: '$backgroundPrimary',
    marginBottom: '$10',
  }),

  WithoutOrders: styled(Flex, {
    padding: '$6 0',
    textAlign: 'center',
    width: '100%',

    '@tablet': {
      gridColumn: 'auto / span 3',
      padding: '$20 0',
    },
  }),

  Wrapper: styled(Box, {
    background: '$backgroundPrimary',
    textAlign: 'center',
  }),
};

export default styles;
